import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { Eyebrow, FadeUp, MaskLines } from "./Motion";
import { EnquiryForm } from "./EnquiryForm";
import { CONTACT, waLink } from "../../lib/catalog";

export const EnquirySection = ({ preset }) => (
  <section id="enquire" className="grain relative overflow-hidden bg-[#240620] py-14 sm:py-20" data-testid="enquiry-section">
    <div className="pointer-events-none absolute right-[-10%] top-10 h-[480px] w-[480px] rounded-full bg-[#E91E63]/15 blur-[130px]" />
    <div className="relative mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Eyebrow>Contact us</Eyebrow>
        <h2 className="mt-4 font-display text-5xl font-medium leading-[0.95] text-[#FFF8EF] sm:text-6xl">
          <MaskLines lines={["Tell us the day.", <span key="i" className="italic text-gold-foil">We'll bring the bloom.</span>]} />
        </h2>
        <FadeUp delay={0.15} className="mt-10 space-y-6">
          <a href={`tel:${CONTACT.tel}`} className="group block" data-testid="contact-phone">
            <span className="flex items-center gap-2 font-cinzel text-[11px] tracking-[0.3em] text-[#D4AF37]"><Phone size={13} /> Call</span>
            <span className="mt-1 block font-display text-4xl text-[#FFF8EF] transition-colors duration-300 group-hover:text-[#F3E5AB] sm:text-5xl">{CONTACT.phone}</span>
          </a>
          <a href={waLink("Hi SkandaSri Eventz, I'd like to make a booking.")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-[#06260f] transition-transform duration-300 hover:scale-105" data-testid="contact-whatsapp">
            <MessageCircle size={16} /> Contact us on WhatsApp
          </a>
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-[#E8D8C8] hover:text-[#FFF8EF]" data-testid="contact-email"><Mail size={18} className="text-[#D4AF37]" /> {CONTACT.email}</a>
          <p className="flex items-start gap-3 text-[#E8D8C8]" data-testid="contact-address"><MapPin size={18} className="mt-0.5 shrink-0 text-[#D4AF37]" /> {CONTACT.address}</p>
        </FadeUp>
      </div>
      <FadeUp delay={0.1} className="lg:col-span-7">
        <div className="rounded-[28px] border border-[#D4AF37]/25 bg-[#330B2E]/70 p-6 backdrop-blur-xl sm:p-10">
          <h3 className="mb-6 font-display text-3xl text-[#FFF8EF]">Send an enquiry</h3>
          <EnquiryForm preset={preset} />
        </div>
      </FadeUp>
    </div>
  </section>
);
